import { forwardRef, useEffect, useRef, useState } from "react";
import { Datepicker as ReactDatepicker } from "@mobiscroll/react";
import cx from "classnames";
import moment from "moment-timezone";
import PropTypes from "prop-types";

import styles from "./Timepicker.module.scss";

const Timepicker = forwardRef(
  ({ className, onChange, onBlur, placeholder, value, ...rest }, ref) => {
    const [timeValue, setTimeValue] = useState(
      value && moment(value, "HH:mm", true).isValid()
        ? moment(value, "HH:mm").format("hh:mm A")
        : null
    );
    const justClosedRef = useRef(false);

    useEffect(() => {
      setTimeValue(
        value && moment(value, "HH:mm", true).isValid()
          ? moment(value, "HH:mm").format("hh:mm A")
          : null
      );
    }, [value]);

    const handleBlur = () => {
      if (justClosedRef.current) {
        justClosedRef.current = false;
        return;
      }

      const currentFormattedValue =
        value && moment(value, "HH:mm", true).isValid()
          ? moment(value, "HH:mm").format("hh:mm A")
          : null;
      if (timeValue !== currentFormattedValue) {
        if (onBlur) {
          onBlur(timeValue);
        } else {
          onChange(timeValue);
        }
      }
    };

    return (
      <div className={cx(styles.wrapper, className)}>
        <ReactDatepicker
          ref={ref}
          timeFormat="hh:mm A"
          themeVariant="light"
          controls={["time"]}
          theme="ios"
          stepMinute={1}
          value={timeValue}
          onChange={(data) => {
            setTimeValue(data.valueText);
          }}
          onClose={(data) => {
            setTimeValue(data.value);
            onChange(data.value);
            justClosedRef.current = true;
            setTimeout(() => {
              justClosedRef.current = false;
            }, 0);
          }}
          inputProps={{
            placeholder,
            onBlur: handleBlur,
          }}
          {...rest}
        />
      </div>
    );
  }
);

Timepicker.defaultProps = {
  className: "",
  placeholder: "",
  value: "",
  onBlur: undefined,
};

Timepicker.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  value: PropTypes.string,
};

export default Timepicker;
